// Overgezet uit naslag/server/server/generateData/tasksPerCategory/Onderhoud.ts.
import { TaskType } from '../../types/tasks.js';
import { InGameEffect } from '../../types/inGameEffect.js';
const taskEffects = [
    {
        type: InGameEffect.diceYellow,
        description: 'vervang een slijtage resultaat van de risico randomizer',
    },
];
export const OnderhoudsTaken = [
    {
        _id: 'onderhoud0',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 1000,
        description: 'Stel een onderhoudsplan op, op basis van FMECA',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 1,
        taskEffects,
    },
    {
        _id: 'onderhoud1',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 1000,
        description: 'Stel een onderhoudsplan op, op basis van voorschriften',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 1,
        taskEffects,
    },
    {
        _id: 'onderhoud2',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 1500,
        description: 'Richt periodiek onderhoud in',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 1,
        taskEffects,
    },
    {
        _id: 'onderhoud3',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 1500,
        description: 'Verbeter je storingsdienst',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 4,
        taskEffects,
    },
    {
        _id: 'onderhoud4',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 1500,
        description: 'Bespaar op preventief onderhoud',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 5,
        taskEffects,
    },
    {
        _id: 'onderhoud5',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 1500,
        description: 'Voer acties uit op basis van monitoring data',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 4,
        taskEffects,
    },
    {
        _id: 'onderhoud6',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 2000,
        description: 'Huur contracter in voor specialistisch preventief onderhoud',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 3,
        taskEffects,
    },
    {
        _id: 'onderhoud7',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 2000,
        description: 'Verbeter je onderhoudsplannen op basis van je storingsdata',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 3,
        taskEffects,
    },
    {
        _id: 'onderhoud8',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 2000,
        description: 'Schaf een nieuwe werkbank aan',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 2,
        taskEffects,
    },
    {
        _id: 'onderhoud9',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 2000,
        description: 'Plaats schaduwborden voor het gereedschap van je monteurs',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 1,
        taskEffects,
    },
    {
        _id: 'onderhoud10',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 2000,
        description: 'Schaf nieuw gereedschap aan voor je monteurs',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 2,
        taskEffects,
    },
    {
        _id: 'onderhoud11',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 2000,
        description: 'Voer een grondoorzaakanalyse uit voor je grootste storingen',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 5,
        taskEffects,
    },
    {
        _id: 'onderhoud12',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 2000,
        description: 'Laat je werkvoorbereider meelopen met de monteurs, zodat hij beter wordt in zijn werk',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 3,
        taskEffects,
    },
    {
        _id: 'onderhoud13',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 3000,
        description: 'Verbeter de werkinstructies van je onderhoudsplannen',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 1,
        taskEffects,
    },
    {
        _id: 'onderhoud14',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 3000,
        description: 'Stel een meerjarenonderhoudsplan op',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 1,
        taskEffects,
    },
    {
        _id: 'onderhoud15',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 4000,
        description: 'Verbeter je onderhoudsplannen op basis van continue conditiemetingen',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 2,
        taskEffects,
    },
    {
        _id: 'onderhoud16',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 5000,
        description: 'Schaf AR-brillen aan voor je monteurs, met daarin visuele werkinstructies',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 1,
        taskEffects,
    },
    {
        _id: 'onderhoud17',
        type: TaskType.onderhoud,
        title: 'Preventief onderhoud',
        cost: 6000,
        description: 'Optimaliseer de samenwerking tussen werkvoorbereiding, magazijn en de monteurs',
        inGameEffectDescription: 'vervang een slijtage resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceYellow],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 3,
        taskEffects,
    },
];
